import functions from '../functions.js';
import { details } from './details';
import calendar from  '../calendar.js';
$(() => {
    detailsAccommodation.init();
})

const detailsAccommodation = {
    $object: null,
    object: null,
    $form: null,
    form: null,
    params: {
        objectId : null,
        unitId: null,
        units: [],
        guests: '2,0',
        dates: null,
        dateFrom: null,
        dateTo: null,
        objectGroupId: null,
        language: 'hr'
    },
    unitsTotal: 0,
    unitsTotalOld: 0,
    init() {

        this.$details = $('.object');
        this.params.objectGroupId = this.$details.attr('data-objectgroupid');
        
        if(! this.$details[0] || this.params.objectGroupId != 1) {
            return;
        }

        if(+this.$details.attr('data-dynamicpackage') != 0) {
            return;
        }

        this.$form = $('.availability-form');
        this.form = this.$form[0];

        this.params.objectId = this.$details.attr('data-objectid');
        this.params.calcErrorMessages = $('[data-calcErrorMessages]')[0] ? JSON.parse($('[data-calcErrorMessages]').attr('data-calcErrorMessages')) : null;

        const $serviceCode = $('[name="serviceCode"]');
        if($serviceCode.length) {
            this.params.serviceCode = $serviceCode.val();
        }

        this.getParams();
        $('[name="guests"]').val(this.params.guests).trigger('change');

        if($('.datepicker-range')[0] && this.params.dateFrom && this.params.dateTo) {
            $('.datepicker-range')[0]._flatpickr.setDate([this.params.dateFrom, this.params.dateTo]);
            this.getCalculation();
        }
        if(this.params.dateFrom && this.params.dateTo) {
            $('.units-dates').text(functions.formatDate(this.params.dateFrom) + ' - ' + functions.formatDate(this.params.dateTo));
        }

        $(window).on('hashchange', e => {
            this.getParams();
            detailsAccommodation.calc = {};
            this.getCalculation();
        });

        $('[name="dates"], [name="guests"], [name="serviceCode"]').on('change', e => {
            const data = functions.getFormData(this.$form);

            this.splitCalendarDates($(e.target).val());
            $('.units-dates').text(functions.formatDate(this.params.dateFrom) + ' - ' + functions.formatDate(this.params.dateTo));

            this.params.guests = data.guests;
            this.params.serviceCode = data.serviceCode;

            functions.setUrlData({
                'dateFrom': this.params.dateFrom,
                'dateTo': this.params.dateTo,
                'serviceCode': this.params.serviceCode,
                'guests': this.params.guests
            }, true, true);
        });

        $('.add-item').on('click', e => {
            let $target = $(e.target);
            $target = $target.attr('data-unitid') ? $target : $target.parents('[data-unitid]');
            let unitId = $target.attr('data-unitid');

            if(detailsAccommodation.calc[unitId] && details.isBookable(detailsAccommodation.calc[unitId])) {
                let unitCalc = detailsAccommodation.calc[unitId].calc;
                let unitTotal = unitCalc.total;
                let totalOld = 0;

                unitCalc.items.forEach(item => {
                    if(item.itemType == 'baseRate') {
                        totalOld += item.itemTotal;
                    }
                });

                this.params.units.push({
                    'unitId': unitId,
                    'total': unitTotal,
                    'totalOld': totalOld > unitTotal ? totalOld : 0,
                });
            }

            detailsAccommodation.setCalSummary();

        });

        $('form.availability-form').on('submit', e => {
            e.preventDefault();
            const $target = $(e.currentTarget);
            const data = functions.getFormData($target);

            this.splitCalendarDates([name="dates"].val());
            $('.units-dates').text(functions.formatDate(this.params.dateFrom) + ' - ' + functions.formatDate(this.params.dateTo));

            this.params.guests = data.guests;
            this.params.serviceCode = data.serviceCode;

            functions.setUrlData({
                'dateFrom': this.params.dateFrom,
                'dateTo': this.params.dateTo,
                'guests': this.params.guests,
                'serviceCode': this.params.serviceCode,
            }, true, true);
            //this.getCalculation();
        });

        $('body').on('click','.remove-item',function(){
            let $target = $(this);
            $target = $target.attr('data-i') ? $target : $target.parents('[data-i]');
            const idx = $target.attr('data-i');

            detailsAccommodation.params.units = detailsAccommodation.params.units.filter((unit, i)=> {
                return i != idx;
            });

            detailsAccommodation.setCalSummary();
        });
    },
    setCalSummary() {
        this.unitsTotal = 0;
        this.unitsTotalOld = 0;

        $('.units-rooms').text('');
        let cart = [];
        this.params.units.forEach((unit, i) => {
            unit.name = $('.unit-name[data-unitid=' + unit.unitId + ']').text();
            this.unitsTotal += unit.total;
            this.unitsTotalOld += unit.totalOld;

            let guests = 0;
            let adults = parseInt(this.params.guests.split(',')[0]);
            let kids = parseInt(this.params.guests.split(',')[1]);
            guests += adults + kids;

            $('.units-rooms').append('<div class="unit-room" data-unitid="' + unit.unitId + '" data-i="' + i + '"><button class="remove-item btn btn-dark px-1 py-0" data-unitid="' + unit.unitId + '"><i class="las la-times-circle la-lg text-danger"></i></button>' + unit.name + ', ' + guests + ' gosta</div>');

            cart.push({
                unitId : unit.unitId,
                dateFrom : this.params.dateFrom,
                dateTo : this.params.dateTo,
                serviceCode : this.params.serviceCode,
                guests : this.params.guests
            })
        });

        $('.units-total').text(functions.formatMoney(this.unitsTotal, 0, '.', ','));
        if(this.unitsTotalOld > this.unitsTotal) {
            $('.units-total-old').text(functions.formatMoney(this.unitsTotalOld, 0, '.', ','));
        } else {
            $('.units-total-old').text('');
        }

        if (cart.length) {
            $('.btn-booking').attr('href',
                $('.btn-booking').attr('href').split('?')[0] +
                '?cart=' + JSON.stringify(cart)
            );

            $('.btn-booking').removeClass('disabled');
        } else {
            $('.btn-booking').addClass('disabled');
            $('.btn-booking').attr('href', $('.btn-booking').attr('href').split('?')[0]);
        }
    },

    getParams() {
        this.params = details.getParams(this.params, this.defaults);
        this.params.guests = this.params.guests && this.params.guests.startsWith('0') ? null : this.params.guests;
        if(this.params.dates) {
            this.splitCalendarDates(this.params.dates);
        }
    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(' - ');
            this.params.dateFrom = aDates[0] ? aDates[0] : null;
            this.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    getCalculation(unitId = null) {

        const dateFrom = this.params.dateFrom;
        const dateTo = this.params.dateTo;
        const guests = this.params.guests;
        const serviceCode = this.params.serviceCode;

        if(
            (this.params.objectId || unitId)
            && guests
            && dateFrom
            && dateTo
            && this.params.objectGroupId
        ) {

            return $.getJSON(
                location.protocol
                + '//'
                + location.hostname
                + '/services/calculation/'
                + (unitId ? '?unitId=' + unitId : '?objectId=' + this.params.objectId)
                + '&guests=' + guests
                + '&dateFrom=' + dateFrom
                + '&dateTo=' + dateTo
                + '&objectGroupId=' + this.params.objectGroupId
                + (serviceCode ? '&serviceCode=' + serviceCode : '')
                + '&language=' + functions.getLang()
            )
                .done($.proxy(function (response) {

                    //console.log(response);

                    if(response.status) {
                        const data = response.data || [];
                        detailsAccommodation.calc = data;

                        Object.entries(data).forEach(unit => {
                            const unitId = unit[0];
                            const unitData = unit[1];

                            const $btnBooking = $('.btn-booking');

                            if(details.isBookable(unitData)) {
                                const unitCalc = unitData.calc;

                                let total = unitCalc.currencySymbol;
                                let unitTotal = unitCalc ? unitCalc.total : 0;
                                let unitTotalOld = null;

                                 unitCalc.items.forEach(item => {
                                    if(item.itemType == 'baseRate') {
                                        unitTotalOld = item.itemTotal;
                                        if(unitTotalOld > unitTotal) {
                                            total += '<del class="text-danger ml-2">' + functions.formatMoney(unitTotalOld, 0, '.', ',') + '</del>';
                                        }
                                    }
                                });

                                total += '<span class="ml-2">' + functions.formatMoney(unitTotal, 0, '.', ',') + '</span>';

                                $('.unit-price-total[data-unitid=' + unitId + ']').html(total);
                                $('.unit-price-total[data-unitid=' + unitId + ']').removeClass('d-none');
                                $('.unit-total-price[data-unitid=' + unitId + ']').removeClass('d-none');
                                $('.unit-price-from[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-price-night[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-price-container[data-unitid=' + unitId + ']').removeClass('d-none');
                                $('.unit-error-container[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-payment-type[data-unitid=' + unitId + ']').addClass('d-none');

                                $('.add-item[data-unitid=' + unitId + ']').removeClass('disabled');

                            } else {

                                $('.unit-error-container[data-unitid=' + unitId + ']').removeClass('d-none').html(details.getCalcErrorMessage(detailsAccommodation.params.calcErrorMessages, unitData));
                                $('.unit-price-container[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-price-total[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-total-price[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-price-from[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-price-night[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-payment-type[data-unitid=' + unitId + ']').addClass('d-none');

                                $('.add-item[data-unitid=' + unitId + ']').addClass('disabled');

                                $btnBooking.addClass('disabled');
                            }

                        });
                    }

                }, window)).fail(function (error) {
                    console.log(error);
                });
        }

        else {
            $('.btn-booking').addClass('disabled');
        }

    },
    loader($target = null) {
        $target ? $target.addClass('active') : $('.unit-spinner').addClass('active');
        setTimeout(() => {
            $target ? $target.removeClass('active') : $('.unit-spinner').removeClass('active');
        }, 800);
    }
};
